import React, { ReactNode, useEffect } from 'react';
import { MainComponentView } from './MainComponentView';
import { BrowserRouter as Router, withRouter, Route, Redirect} from 'react-router-dom';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { WprSwitch } from '../../wpr-framework/component/route/WprSwitch';
import ContractNoticeComponent from '../contract-notice/ContractNoticeComponent';
import PlanComponent from '../plan/PlanComponent';
import CompleteMailComponent from '../complete-mail/CompleteMailComponent';
import ErrorComponent from '../error/ErrorComponent';
import FinishComponent from '../finish/FinishComponent';
import SelectPaymentComponent from '../select-payment/SelectPaymentComponent';
import CreditComponent from '../credit/CreditComponent';
import PersonalInfoComponent from '../personal-info/PersonalInfoComponent';
import ConfirmComponent from '../confirm/ConfirmComponent';
import RiskFactorComponent from '../risk-factor/RiskFactorComponent';
import RegistMailComponent from '../regist-mail/RegistMailComponent';
import SettlementComponent from '../settlement/SettlementComponent';
import '../../../public/style.css';
import PayPayRedirectComponent from '../paypay-redirect/PayPayRedirectComponent';
import PaymentErrorComponent from '../payment-error/PaymentErrorComponent';
import BlackListErrorComponent from '../black-list-error/BlackListErrorComponent';


/**
 * サンプルメインコンポーネント
 */
class MainComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new MainComponentView(), props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
   * 描画
   */
	public onRender(): ReactNode {
		return (
			<>
				{/* ビルド・デプロイ環境用 */}
				<Router basename={'/TravelWL'}>
				{/* ローカル環境用 */}
				{/* <Router> */}
					<WprSwitch view={this.view}>
						<Route exact path='/' 							component={RiskFactorComponent} 	noUpdate/>
						{/* <Route exact path='/' 							component={PersonalInfoComponent} 	noUpdate			/> */}
						<Route exact path='/step1_riskfactor' 			component={RiskFactorComponent} 	noUpdate/>
						<Route exact path='/step2_plan' 				component={PlanComponent} 			noUpdate			firstRedirect={'/error'} />
						<Route exact path='/step3_important' 			component={ContractNoticeComponent} noUpdate 			firstRedirect={'/error'} />
						<Route exact path='/step4_mail-registration'	component={RegistMailComponent} 	noUpdate			firstRedirect={'/error'} />
						<Route exact path='/step4_mail-finish' 			component={CompleteMailComponent} 	noMove 	noUpdate	firstRedirect={'/error'} />
						<Route exact path='/step5_personal-information' component={PersonalInfoComponent} 	noUpdate			/>
						<Route exact path='/step6_confirm' 				component={ConfirmComponent} 		noUpdate			firstRedirect={'/error'} />
						<Route exact path='/step7_payment' 				component={SelectPaymentComponent} 	noUpdate			firstRedirect={'/error'} />
						<Route exact path='/step7_paypay' 				component={PayPayRedirectComponent} 					firstRedirect={'/error'} />
						<Route exact path='/step7_settlement' 			component={SettlementComponent}     noMove />
						<Route exact path='/step7_creditcard'			component={CreditComponent} 		noUpdate			firstRedirect={'/error'} />
						<Route exact path='/step8_make-contract' 		component={FinishComponent} 		noMove 	noUpdate	firstRedirect={'/error'} />
						<Route exact path='/error' 						component={ErrorComponent} 			noMove 	noUpdate/>
						<Route exact path='/paypayerr' 					component={PaymentErrorComponent}   noMove />
						{/* WRQ-2990_旅行保険　直扱販売のための対応 START */}
						<Route exact path='/b_error' 					component={BlackListErrorComponent} noMove 	noUpdate/>
						{/* WRQ-2990_旅行保険　直扱販売のための対応 END */}
					</WprSwitch>
				</Router>
			</>
		);
	}
	// --------------------------------------------------------------------------
}

export default withRouter(MainComponent);

